import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const SinkwtaxMaster = createSlice({
  name: "SinkwtaxMaster",
  initialState: {
    isLoading: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    sink_wtax_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_sink_wtax_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    failure_api_call_sink_wtax_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    sink_wtax_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
  },
});
export default SinkwtaxMaster.reducer;
export const {
  sink_wtax_master,
  success_api_call_sink_wtax_master,
  sink_wtax_isSuccess,
  failure_api_call_sink_wtax_master,
} = SinkwtaxMaster.actions;
